/* eslint-disable perfectionist/sort-objects */
import { defineTokens } from '@chakra-ui/react';

export const colors = defineTokens({
	colors: {
		primary: {
			10:  { value: '#F2FCFF' },
			50:  { value: '#C4EAFF' },
			100: { value: '#027FC3' },
			120: { value: '#006DA8' },
		},
		secondary: {
			10:  { value: '#DFFFEC' },
			100: { value: '#139F4B' },
			120: { value: '#088C3D' },
		},
		tertiary: {
			10:  { value: '#FFEAD4' },
			100: { value: '#FF7A59' },
			120: { value: '#E6674A' },
		},
		black: { DEFAULT: { value: '#000000' } },
		gray:  {
			10:  { value: '#F8F8F8' },
			100: { value: '#787878' },
			15:  { value: '#EAEAEA' },
			50:  { value: '#BABABA' },
		},
		red: {
			10:  { value: '#FFE5E5' },
			100: { value: '#EB4243' },
		},
		text:   { DEFAULT: { value: '#444444' } },
		white:  { DEFAULT: { value: '#FFFFFF' } },
		yellow: {
			10:  { value: '#FFEAD4' },
			100: { value: '#FAAD5C' },
		},
	},
});
